import { render } from "./IntroMain.vue?vue&type=template&id=2553f2ef"
import script from "./IntroMain.vue?vue&type=script&lang=js"
export * from "./IntroMain.vue?vue&type=script&lang=js"

import exportComponent from "/home/blonix/proj/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__